<template>
  <v-container class="container-card">
    <FiltroRelatorios @selectedFilters="filters = $event" />
    <Relatorios :filters="filters" :list="menus" />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import FiltroRelatorios from "@/components/comissao/relatorios/FiltroRelatorios";
import Relatorios from "@/components/comissao/relatorios/Relatorios";
export default {
  components: {
    FiltroRelatorios,
    Relatorios
  },
  data() {
    return {
      filters: {},
      menus: [
        {
          title: "Relatórios",
          icon: "mdi-file-outline",
          reportList: [
            {
              text: "Empresa Resumo Geral",
              service: "comissaoExtrato",
              permission: 1221
            },
            {
              text: "Realizado Empresas",
              service: "realizadoEmpresa",
              permission: 1008
            },
            {
              text: "Empresa Não Lançamento Pagamento",
              service: "naoPagamento",
              permission: 1222
            },
            {
              text: "Comissao",
              service: "comissaoDetalhado",
              permission: 1223
            }
          ]
        },
        {
          title: "Relatórios Detalhados",
          icon: "mdi-file-outline",
          reportList: [
            {
              text: "Inadimplência",
              service: "inadiplenciaFinanceira",
              permission: 1024
            }
          ]
        }
      ]
    };
  },
  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Relatórios Depto Administrativo");
  }
};
</script>

<style></style>
